import React, { Fragment } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  InputAdornment,
  TextField,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { withStyles } from "@mui/styles";
import { styleSheet } from "./style.js";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
function Move(props) {
  const { open, setOpen, classes } = props;
  return (
    <Fragment>
      <Dialog disablePortal open={open} fullWidth={true} maxWidth={"sm"}>
        <DialogTitle className={classes.modalHeader}>
          <Typography className={classes.modalTitle}>
            Select Destination
          </Typography>
          <IconButton onClick={() => setOpen(false)}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.modalContent}>
          <TextField
            placeholder="Search"
            fullWidth
            size="small"
            className={classes.EditMlsField}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton>
                    <SearchRoundedIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <List sx={{ maxHeight: "400px", overflow: "auto" }}>
            {Array.from(Array(30).keys()).map(() => (
              <ListItem disablePadding>
                <ListItemButton dense>
                  <ListItemIcon sx={{ minWidth: "40px" }}>
                    <FolderRoundedIcon />
                  </ListItemIcon>
                  <ListItemText primary="123 Main Street, Roswell, GA 30075" />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions
          sx={{
            padding: "10px  20px 20px 20px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Button variant="text" className={classes.newFolderButton}>
            Create New Folder
          </Button>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", gap: "12px" }}
          >
            <Button
              onClick={() => setOpen(false)}
              className={classes.cancelButton}
            >
              Cancel
            </Button>
            <Button disabled={false} className={classes.doneButton}>
              Done
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
export default withStyles(styleSheet, { name: "MoveStyle" })(Move);
